import { apiGet, apiPost, apiPut, apiDelete, API_URI } from "api";

const column = {
    get: async (id: number) => {
        const data = apiGet(`${API_URI}/api/column/${id}`);
        return data;
    },
    getAll: async (boardId: number) => {
        const data = await apiGet(`${API_URI}/api/column?boardId=${boardId}`);
        return data;
    },
    getAllArchived: async (boardId: number) => {
        const data = await apiGet(`${API_URI}/api/column/archived?boardId=${boardId}`);
        return data;
    },
    getAllSorted: async (boardId: number, sortOption: number) => {
        const data = await apiGet(`${API_URI}/api/column/sort?boardId=${boardId}&sortOrder=${sortOption}`);
        return data;
    },
    update: async (clientId: number, boardId: number, columnId: number, description: string, position: number) => {
        const data = await apiPut(`${API_URI}/api/column/update`, {
            ClientId: clientId,
            BoardId: boardId,
            ColumnId: columnId,
            Description: description,
            Position: position,
        });
        return data;
    },
    add: async (boardId: number, description: string, position: number, roleId: number) => {
        const data = await apiPost(`${API_URI}/api/column`, {
            BoardId: boardId,
            Description: description,
            Position: position,
            RoleId: roleId,
        });
        return data;
    },
    delete: async (columnId: number) => {
        const data = await apiDelete(`${API_URI}/api/column/${columnId}`);
        return data;
    },
    getTickets: async (columnId: number) => {
        const data = await apiGet(`${API_URI}/api/column/${columnId}/tickets`);
        return data;
    },
    subscription: {
        manageSubscription: async (contactId: number, boardId: number, columnId: number, isActive: boolean) => {
            const data = await apiPost(`${API_URI}/api/column/subscription`, { ContactId: contactId, BoardId: boardId, ColumnId: columnId, IsActive: isActive });
            return data;
        },
        getById: async (columnId: number) => {
            const data = await apiGet(`${API_URI}/api/column/subscription/column/${columnId}`);
            return data;
        },
    },
};

export default column;
